module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox float-e-margins",
    class: {
      'no-padding': _vm.noPadding
    }
  }, [_c('div', {
    staticClass: "ibox-title",
    class: {
      selected: _vm.selected
    }
  }, [_vm._t("title")], 2), _vm._v(" "), (_vm.$slots.heading) ? _c('div', {
    staticClass: "ibox-content ibox-heading"
  }, [_vm._t("heading")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ibox-content",
    class: {
      fixed: _vm.fixed
    },
    style: (_vm.contentStyle)
  }, [_vm._t("content")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f635434","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/common/IBox.vue
// module id = 3170
// module chunks = 3